import React, { FC } from 'react'
import Link from 'next/link'
import { Button } from '@/atoms/Button'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { Image } from '@/atoms/Image'
import { Text } from '@/atoms/Text'
import { slugs } from '@/constants/slugs'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  theatricalSlug: string
  isOpen: boolean
  onClose: () => void
}
export const GuildGiveawayModal: FC<Props> = ({ theatricalSlug, isOpen, onClose }) => {
  const { t } = useTranslate('tickets')

  if (theatricalSlug === slugs.kingOfKings) {
    return (
      <Modal
        backgroundScreenColor="black"
        isOpen={isOpen}
        onClose={onClose}
        panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !overflow-visible !bg-[#050203] shadow-dark-4 rounded-3xl !p-0 relative text-left"
        transition="appear"
        className="z-[99999]"
        childWrapperClassName="!m-0"
      >
        <div className="relative h-[200px] w-full rounded-t-2xl md:h-[300px]">
          <Image
            src="/v1742325400/king-of-kings/acf662caec488527636322cd2a485f85.webp"
            alt=""
            fill
            className="rounded-t-2xl object-cover"
          />
          <div
            style={{ background: 'linear-gradient(180deg, rgba(20, 23, 33, 0) 0%, #141721 100%)' }}
            className="absolute inset-x-0 bottom-0 h-[72px] w-full bg-[#050203]  md:h-[104px]"
          />
        </div>
        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-white p-[10px]" onClick={onClose}>
          <CloseIcon color="core-gray-950" size={20} />
        </div>
        <div className="relative z-40 rounded-b-2xl bg-[#050203] p-6 !pt-8  md:p-11 md:!pt-6">
          <Text weight="bold" className="photon-title-lg md:!photon-heading-sm block text-center !text-[#F1B420]">
            {t('tkokEnterToWinGuildTickets', 'Get More Entries for the $100K Unforgettable Journey Giveaway!')}
          </Text>

          <Text color="white" className="photon-paragraph-sm mt-2 block text-center md:mt-4">
            {t(
              'tkokEnterToWinDescriptionV2GuildTicketsV2',
              'By claiming your Guild Tickets to The King of Kings, you will receive 100 entries into the $100K Unforgettable Journey Giveaway!',
            )}
          </Text>

          <Button className="m-auto my-8 mb-4 w-fit" variant="white" onClick={onClose}>
            {t('claimGuildMovieTickets', 'Claim Movie Tickets')}
          </Button>
          <div className="flex">
            <Link href={'/giveaway/king-of-kings'} target="_blank" className="m-auto text-base text-white underline">
              {t('learnMoreAboutGiveawayTKOK', 'Learn More About the Giveaway')}
            </Link>
          </div>
        </div>
      </Modal>
    )
  }
  if (theatricalSlug === slugs.theLastRodeo) {
    return (
      <Modal
        backgroundScreenColor="black"
        isOpen={isOpen}
        onClose={onClose}
        panelClasses="w-full !max-w-[361px] md:!max-w-[600px] !overflow-visible !bg-[#E5DFD3] shadow-dark-4 rounded-3xl !p-0 relative text-left"
        transition="appear"
        className="z-[99999]"
        childWrapperClassName="!m-0"
      >
        <div className="relative h-[200px] w-full rounded-t-2xl md:h-[300px]">
          <Image src="/v1743123119/the-last-rodeo/keyart.webp" alt="" fill className="rounded-t-2xl object-cover" />
        </div>
        <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-core-gray-950 p-[10px]" onClick={onClose}>
          <CloseIcon color="white" size={20} />
        </div>
        <div className="relative z-40 rounded-b-2xl bg-[#E5DFD3] p-6 !pt-8  md:p-11 md:!pt-6">
          <Text weight="bold" className="photon-title-lg md:!photon-heading-sm block text-center !text-[#D7300F]">
            {t(
              'rodeoEnterToWinGuildTickets',
              'As a Guild member, earn 100 bonus entries when you redeem your Guild tickets today!',
            )}
          </Text>

          <Text color="black" className="photon-paragraph-sm mt-2 block text-center md:mt-4">
            {t(
              'rodeoEnterToWinDescriptionV2GuildTicketsV2',
              'By claiming your Guild Tickets to The Last Rodeo, you will receive 100 entries into the $350K Adventure Package Giveaway!',
            )}
          </Text>

          <Button className="m-auto my-8 mb-4 w-fit" variant="black" onClick={onClose}>
            {t('claimGuildMovieTickets', 'Claim Movie Tickets')}
          </Button>
          <div className="flex">
            <Link href={'/giveaway/last-rodeo'} target="_blank" className="m-auto text-base text-black underline">
              {t('learnMoreAboutGiveawayTKOK', 'Learn More About the Giveaway')}
            </Link>
          </div>
        </div>
      </Modal>
    )
  }

  return null
}
